import { Box, Container, Group } from '@mantine/core';
import { PopularTagComponent, TagComponent } from './TechblogCard';
import { isDark, useReplaceQueryParams } from '@/utils/utils';

import BookmarkButton from '@/components/Buttons/BookmarkButton';
import { COMPANY_LOGO_ENDPOINT } from '@/config/endpoint';
import DMText from '@/components/DMText';
import { ITechblogDetail } from '@/types/techblog';
import Image from 'next/image';
import { NewTag } from '@/components/Badge';
import Skeleton from '@/components/Skeleton';
import { imageOpt } from '@/utils/images';
import themeVariables from '@/styles/themeVariables';
import { useTechblogCardMobileStyles } from '../techblog.style';

export type CardProps = {
  loading: boolean;
  handleCardClick(): void;
  handleBookmarkClicked: any;
  techblog: ITechblogDetail;
  bookmarkStatus: boolean;
};

const MobileCard = ({
  loading,
  handleCardClick,
  handleBookmarkClicked,
  techblog,
  bookmarkStatus,
}: CardProps) => {
  const { dark } = isDark();

  const mobileStyles = useTechblogCardMobileStyles({ dark });

  const { urlSearchParams, setQueryParams } = useReplaceQueryParams();
  const { company_id, title, published, summary, tag, is_popular } = techblog;

  const clickLogo = (id) => (e) => {
    e.stopPropagation();

    urlSearchParams.set('company_id', id);
    setQueryParams(urlSearchParams);
  };

  if (loading) {
    return (
      <Container className={mobileStyles.classes.skeletonContainer}>
        <Skeleton lines={5} height={180} />
      </Container>
    );
  }

  return (
    <div
      className={mobileStyles.classes.outerContainer}
      onClick={handleCardClick}
    >
      <Group mb={16} spacing={12}>
        <Image
          className={mobileStyles.classes.logoImage}
          width={42}
          height={42}
          src={imageOpt(`${COMPANY_LOGO_ENDPOINT}/${company_id}.png`, 100)}
          alt="logo"
          onClick={clickLogo(company_id)}
          style={{ backgroundColor: '#fff' }}
        />
        <NewTag published={published} />
        <PopularTagComponent isPopular={is_popular} />
        <Box className={mobileStyles.classes.bookmarkButton}>
          <BookmarkButton
            size={21}
            active={bookmarkStatus}
            onClick={handleBookmarkClicked}
          />
        </Box>
      </Group>
      <DMText
        className={mobileStyles.classes.title}
        dColor={themeVariables.darkMode.strong}
      >
        {title}
      </DMText>
      <DMText
        lineClamp={3}
        className={mobileStyles.classes.summary}
        dColor={themeVariables.darkMode.alternative}
      >
        {summary}
      </DMText>
      <div className={mobileStyles.classes.tagContainer}>
        <TagComponent tag={tag} />
      </div>
      <DMText
        className={mobileStyles.classes.footerDate}
        dColor={themeVariables.darkMode.neutral}
      >{`${new Date(published).toLocaleDateString()}`}</DMText>
    </div>
  );
};

export default MobileCard;
